export default __webpack_public_path__ + "static/media/LENS_CULINARIS_SIRE_complete_2.148f7e38.jpg";